import { Themed } from 'theme-ui'
import { useDataSelector } from '@uswitch/ev-utils/lib/context/selectors'
import { parseTrackingUrl } from '@uswitch/ev-utils/lib/tracking'

const sameHostParams = (host, href = '') => {
  try {
    const sameHost = host === new URL(href).host
    return sameHost ? {} : { target: '_blank', rel: 'noopener noreferrer' }
  } catch (e) {
    return {}
  }
}

export const LinkWrapper = ({ children, className, href, ...props }) => {
  const host = useDataSelector(['location', 'host'])
  const hostParams = sameHostParams(host, href)

  const [trimmedHref, dataAttributes] = parseTrackingUrl(href)
  return (
    <a href={trimmedHref} {...dataAttributes} {...props} {...hostParams} className={className}>
      {children}
    </a>
  )
}

const Link = ({ children, variant = '', href = '', className, ...props }) => {
  const [trimmedHref, dataAttributes] = parseTrackingUrl(href)

  return (
    <Themed.a
      className={`${variant} ${className}`}
      href={href.startsWith('#') ? trimmedHref.toLowerCase() : trimmedHref}
      {...dataAttributes}
      {...props}
      sx={{ variant: `styles.a.${variant}` }}
    >
      <span sx={{ variant: 'elements.link-with-chevron' }}>{children}</span>
    </Themed.a>
  )
}

export const LinkConnected = props => {
  const host = useDataSelector(['location', 'host'])
  const sameHost = sameHostParams(host, props.href)

  return <Link {...props} {...sameHost} />
}
